import type { WidgetType } from '@/types/dashboard';
import { WIDGET_REGISTRY } from '@/types/widgets';
import { t } from '@/i18n';

interface AddPanelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (type: WidgetType) => void;
}

export function AddPanelModal({ isOpen, onClose, onSelect }: AddPanelModalProps) {
  if (!isOpen) {
    return null;
  }

  const handleSelect = (type: WidgetType) => {
    onSelect(type);
    onClose();
  };

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t('dashboard.addPanel')}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            />
          </div>
          <div className="modal-body">
            <div className="row g-3">
              {WIDGET_REGISTRY.map((item) => (
                <div key={item.type} className="col-6">
                  <div
                    data-testid={`widget-card-${item.type}`}
                    className="card h-100"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(item.type)}
                  >
                    <div className="card-body text-center">
                      <i className={item.icon} style={{ fontSize: '2rem' }} />
                      <h6 className="card-title mt-2">{t(item.label)}</h6>
                      <p className="card-text small text-muted">{t(item.description)}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
